import {Component, store} from '../../index';
import {getTranslation, getCurrentPrice, numberFormat, addCurrencySymbol, getCurrentPriceOnly, calculateTotalOldPrice, isTrialPlan, calculateDiscountedAmountAndPercentage} from '../index';
export default class PlanBoxes extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('.cart-boxes-wrapper'),
      state: store.state,
    });
  }
  render() {
    let mainCartBox = document.querySelectorAll('.cart-box');
    let selectedCurrency = cartState.currency_code;

    for (let plan_currency in cartState.plans_currency) {

      let sumRequiredAddonPrice = calculateTotalOldPrice(1, cartState.old_prices, selectedCurrency, cartState.plans[plan_currency]);
      let months = parseInt(cartState.count_extra_month) === 1 ? cartState.plans[plan_currency].months : cartState.plans[plan_currency].interval_length;
      let planPrice = cartState.plans[plan_currency].discounted_amount > 0 ? cartState.plans[plan_currency].discounted_amount : cartState.plans[plan_currency].unit_amount;
      const planPricePerMonth = cartState.plans[plan_currency].per_month;
      const planTotalPrice = planPrice > 0 ? planPrice : (cartState.plans[plan_currency].full_per_month * months);
      const planOldTotalPrice = calculateTotalOldPrice(months, cartState.old_prices, selectedCurrency, cartState.plans[plan_currency]);

      // Month price
      let planBoxPrice = mainCartBox[plan_currency].querySelector('.cart-box .cart-box-price b');
      if(planBoxPrice) {
        planBoxPrice.innerHTML = `${numberFormat(cartState.plans[plan_currency].per_month)}<sup>${cartState.currencies_symbol[selectedCurrency]}</sup>`;
      }

      // Cut Price
      let planBoxCutPrice = mainCartBox[plan_currency].querySelector('.cart-box .cart-box-month-div');
      if(planBoxCutPrice) {
        planBoxCutPrice.innerHTML = (planPricePerMonth < sumRequiredAddonPrice) ? `<span class="dt-ppl"><del>${addCurrencySymbol(numberFormat(sumRequiredAddonPrice))}</del></span>` : '';
      }

      // Discount percentage
      let planBoxDiscountPrice = mainCartBox[plan_currency].querySelector('.cart-box .discount-price');
      if (planBoxDiscountPrice) {
        let [discountPercentage, discountAmount] = calculateDiscountedAmountAndPercentage(Number(planOldTotalPrice),Number(planTotalPrice));
        if (!isTrialPlan(cartState.plans[plan_currency]) && Number(discountAmount) > 0) {
          planBoxDiscountPrice.innerHTML = `${discountPercentage}% ${getTranslation(`off`)}`;
        } else {
          planBoxDiscountPrice.innerHTML = `${getTranslation(`no_discount`)}`;
        }
      }

      // Displaying Billed Text
      var cartBoxInner = mainCartBox[plan_currency].querySelector('.cart-box .fpdr-text');
      if(cartBoxInner && cartBoxInner.innerHTML){
        cartBoxInner.innerHTML = cartState.plans[plan_currency].labels['fpdr_text_label'].replace(/\(price\)/g,getCurrentPriceOnly(cartState.plans[plan_currency]));
        cartBoxInner.innerHTML = cartBoxInner.innerHTML.replace(/\(discounted-price\)/g,getCurrentPrice(cartState.plans[plan_currency]));
        cartBoxInner.innerHTML = cartBoxInner.innerHTML.replace(/\(month-price\)/g,`${cartState.plans[plan_currency].per_month}${cartState.currencies_symbol[selectedCurrency]}`);
      }
      var cartBoxInner = mainCartBox[plan_currency].querySelector('.cart-box .cart-box-inner .cart-box-btm-text span');
      if(cartBoxInner && cartBoxInner.innerHTML){
        cartBoxInner.innerHTML = cartState.plans[plan_currency].labels['money_back_label'].replace(/\(price\)/g,getCurrentPriceOnly(cartState.plans[plan_currency]));
        cartBoxInner.innerHTML = cartBoxInner.innerHTML.replace(/\(discounted-price\)/g,getCurrentPrice(cartState.plans[plan_currency]));
        cartBoxInner.innerHTML = cartBoxInner.innerHTML.replace(/\(month-price\)/g,`${cartState.plans[plan_currency].per_month}${cartState.currencies_symbol[selectedCurrency]}`);
      }
    }
  }
}